import {useFetch} from "nuxt/app";

export function useCategories() {
	return useFetch("/api/categories");
}
